export default function() {
  'ngInject';

  function getStyle(element, acpen, adminRegistration, eventLink, eventStyle, scorm, forbidden) {
    const type = getElementType(element);
    if (forbidden) return `${type}-success`;
    if (adminRegistration) return `${type}-white`;
    if (eventStyle === 'invitation') return `${type}-success`;
    if ((scorm || acpen) && eventStyle === 'registered') return `${type}-success`;
    if (eventStyle === 'registered' || eventStyle === 'userRegistered') return `${type}-danger`;
    if (eventLink || eventStyle === undefined) return `${type}-basic`;
    if (eventStyle === 'reviewed') return `${type}-primary`;
    if (eventStyle === 'bundlePurchase') return `${type}-primary`;
    if (eventStyle === 'completed') return `${type}-success`;
    if (eventStyle === 'final') return `${type}-success`;
    if (eventStyle === 'started') return `${type}-success`;
    return `${type}-primary`;
  }

  function getText(
    acpen,
    adminRegistration,
    eventLink,
    eventStyle,
    purchase,
    scorm,
    waitlist,
    full,
    external,
    forbidden,
    expired
  ) {
    if (forbidden) return 'Sign In / Sign Up';
    if (eventStyle === 'reviewed') return 'Launch';
    if (eventStyle === 'completed') return 'Launch';
    if (expired) return 'Expired';
    if (eventStyle === 'bundlePurchase') return 'Purchase Bundle';
    if (external) return 'External';
    if (adminRegistration) return 'Register Team Member';
    if ((scorm || acpen) && eventStyle === 'registered') return 'Launch';
    if (eventStyle === 'invitation') return 'Register';
    if (purchase && eventStyle === 'registered') return 'Purchased';
    if (eventStyle === 'registered' || eventStyle === 'userRegistered') return 'Unregister';
    if (eventLink || eventStyle === undefined) return 'Register';
    if (eventStyle === 'final') return 'Launch';
    if (eventStyle === 'started') return 'Launch';
    if (eventStyle === 'waitlisted') return 'Waitlisted';
    if (purchase) return 'Purchase';
    if (full) return 'Full';
    if (waitlist) return 'Waitlist';
    return 'Register';
  }

  function getElementType(element) {
    const defaultType = 'btn';

    if (!element || !element.classList) return defaultType;

    const classList = Object.values(element.classList);

    if (classList.includes('label')) return 'label';
    if (classList.includes('badge')) return 'badge';
    return defaultType;
  }

  return {
    restrict: 'A',
    scope: {
      acpen: '<',
      adminRegistration: '<',
      eventLink: '<',
      eventStyle: '=',
      purchase: '<',
      scorm: '<',
      waitlist: '<',
      full: '<',
      external: '<',
      forbidden: '<',
      expired: '<'
    },
    link: function(scope, element) {
      let tempStyle;

      scope.update = () => {
        tempStyle = getStyle(
          element[0],
          scope.acpen,
          scope.adminRegistration,
          scope.eventLink,
          scope.eventStyle,
          scope.scorm,
          scope.forbidden
        );
        element.addClass(tempStyle);
        element[0].innerHTML = getText(
          scope.acpen,
          scope.adminRegistration,
          scope.eventLink,
          scope.eventStyle,
          scope.purchase,
          scope.scorm,
          scope.waitlist,
          scope.full,
          scope.external,
          scope.forbidden,
          scope.expired
        );
      };

      scope.$watch('eventStyle', (newStatus, oldStatus) => {
        if (oldStatus) {
          element.removeClass(tempStyle);
        }
        scope.update();
      });

      scope.update();
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/eventStyle/index.js